
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/covid-policy",
      function () {
        return require("private-next-pages/covid-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/covid-policy"])
      });
    }
  